module.exports = __webpack_public_path__ + "static/img/アセット 31@2x.8d0db55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 31@2x.png
// module id = 7tJi
// module chunks = 1